export const businessInfo = {
  name: "Laboratorio Clínico ANEDAN",
  shortName: "ANEDAN",
  tagline: "Análisis clínicos y ultrasonido con trato humano",
  logo: "https://public.readdy.ai/ai/img_res/e9721356-666b-4b87-89bd-198606b9dd38.png",
  logoWhite: "https://public.readdy.ai/ai/img_res/4ef1d4a7-aeb6-4325-8cc4-0e406ca88ebb.png",
  emblem: "https://public.readdy.ai/ai/img_res/fce8b602-04f9-4af3-aa67-3dcfa9ab99d7.png",
  phoneDisplay: "55 3006 2938",
  phoneLink: "tel:+525530062938",
  whatsappLink: "https://wa.me/525530062938",
  hours: "Abrimos a las 7:00 a.m.",
  hoursFull: "Lunes a Sábado · 7:00 a.m. a 1:00 p.m.",
  hoursNote: "Domingo: cerrado",
  hoursOpens: "07:00",
  hoursCloses: "13:00",
  address: "Cda. Novedades 92, Prensa Nacional, 54170 Tlalnepantla, Estado de México.",
  city: "Tlalnepantla, Estado de México",
  rating: "5.0",
  reviewCount: 5,
  mapsEmbed:
    "https://www.google.com/maps?q=Cda.%20Novedades%2092%2C%20Prensa%20Nacional%2C%2054170%20Tlalnepantla%2C%20Estado%20de%20M%C3%A9xico&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Cda.%20Novedades%2092%2C%20Prensa%20Nacional%2C%2054170%20Tlalnepantla%2C%20Estado%20de%20M%C3%A9xico",
};

export const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Servicios", href: "#servicios" },
  { label: "Testimonios", href: "#testimonios" },
  { label: "Preguntas", href: "#preguntas" },
  { label: "Contacto", href: "#contacto" },
];

export const stats = [
  { value: "5.0", label: "Calificación en Google", icon: "ri-star-smile-line" },
  { value: "7:00 a.m.", label: "Abrimos temprano", icon: "ri-time-line" },
  { value: "100%", label: "Atención personalizada", icon: "ri-heart-3-line" },
  { value: "4", label: "Servicios: análisis, ultrasonido, ECG y rayos X", icon: "ri-microscope-line" },
];

export const values = [
  {
    title: "Calidad y precisión",
    description:
      "Procesos cuidados y resultados confiables en cada estudio, para que tú y tu médico tomen decisiones con seguridad.",
    icon: "ri-award-line",
  },
  {
    title: "Precios accesibles",
    description:
      "Estudios de laboratorio a precios justos, sin sorpresas. Cuidar tu salud no tiene por qué ser caro.",
    icon: "ri-hand-coin-line",
  },
  {
    title: "Atención profesional y paciente",
    description:
      "Nuestro equipo te explica todo el proceso con calma y responde cada duda, sin prisas ni tecnicismos.",
    icon: "ri-user-heart-line",
  },
  {
    title: "Espacio seguro e inclusivo",
    description:
      "Somos un laboratorio amigable con la comunidad LGBTQ+. Aquí te recibimos con respeto y sin juicios.",
    icon: "ri-shake-hands-line",
  },
  {
    title: "Instalaciones limpias y organizadas",
    description:
      "Higiene, orden y comodidad en cada rincón, porque tu bienestar empieza desde que llegas.",
    icon: "ri-home-heart-line",
  },
  {
    title: "Cerca de ti, todos los días",
    description:
      "Abrimos a las 7:00 a.m. para que puedas hacerte tus estudios antes de empezar tu día, en Tlalnepantla.",
    icon: "ri-map-pin-2-line",
  },
];

export const services = [
  {
    title: "Análisis clínicos de rutina",
    badge: "",
    description:
      "Estudios de laboratorio confiables para tu chequeo, control o diagnóstico, con resultados claros y entrega puntual.",
    icon: "ri-test-tube-line",
    image:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20clean%20clinical%20laboratory%20blood%20sample%20vials%20in%20a%20rack%2C%20soft%20natural%20light%2C%20teal%20turquoise%20and%20deep%20navy%20blue%20tones%2C%20minimalist%20hygienic%20medical%20photography%2C%20calm%20professional%20atmosphere%2C%20shallow%20depth%20of%20field&width=900&height=900&seq=anedan-analysis-01&orientation=squarish&nocache=true",
    items: [
      "Biometría hemática completa",
      "Química sanguínea y glucosa",
      "Perfil de lípidos (colesterol y triglicéridos)",
      "Pruebas de función hepática y renal",
      "Examen general de orina",
      "Perfil tiroideo y hormonas",
      "Pruebas de embarazo",
      "Perfil preoperatorio y de rutina",
    ],
  },
  {
    title: "Ultrasonido",
    badge: "",
    description:
      "Ultrasonido realizado por un médico profesional y paciente, que te acompaña y resuelve cada duda durante el estudio.",
    icon: "ri-heart-pulse-line",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20ultrasound%20machine%20in%20a%20bright%20clean%20medical%20clinic%20room%2C%20soft%20natural%20lighting%2C%20teal%20turquoise%20and%20deep%20navy%20blue%20tones%2C%20minimalist%20hygienic%20calm%20atmosphere%2C%20professional%20medical%20photography%2C%20no%20people&width=900&height=900&seq=anedan-ultrasound-01&orientation=squarish&nocache=true",
    items: [
      "Ultrasonido abdominal",
      "Ultrasonido de hígado y vías biliares",
      "Ultrasonido renal y vías urinarias",
      "Ultrasonido tiroideo",
      "Ultrasonido de partes blandas",
      "Ultrasonido prostático",
      "Interpretación por médico especialista",
    ],
  },
  {
    title: "Electrocardiograma",
    description:
      "Estudio del ritmo y la actividad eléctrica del corazón, realizado por personal capacitado en el laboratorio o a domicilio, con cita previa.",
    icon: "ri-heart-3-line",
    badge: "",
    image:
      "https://readdy.ai/api/search-image?query=Electrocardiogram%20ECG%20machine%20with%20leads%20and%20a%20glowing%20heart%20rhythm%20wave%20on%20its%20screen%20in%20a%20bright%20clean%20medical%20setting%2C%20teal%20turquoise%20and%20deep%20navy%20blue%20tones%2C%20minimalist%20hygienic%20professional%20healthcare%20photography%2C%20calm%20trustworthy%20atmosphere%2C%20no%20people&width=900&height=900&seq=anedan-ecg-01&orientation=squarish",
    items: [
      "Electrocardiograma de reposo (12 derivaciones)",
      "Detección de arritmias y alteraciones del ritmo",
      "Valoración previa a cirugía",
      "Control de hipertensión y cardiopatías",
      "Informe interpretado por médico",
      "Disponible en el laboratorio o a domicilio, con cita previa",
    ],
  },
  {
    title: "Rayos X",
    description:
      "Radiografías para tu diagnóstico sin moverte de casa. Llevamos el equipo hasta ti con la seguridad y el cuidado que mereces.",
    icon: "ri-scan-2-line",
    badge: "Solo a domicilio",
    image:
      "https://readdy.ai/api/search-image?query=Portable%20digital%20X-ray%20radiography%20machine%20equipment%20in%20a%20bright%20clean%20medical%20room%2C%20teal%20turquoise%20and%20deep%20navy%20blue%20tones%2C%20minimalist%20hygienic%20professional%20healthcare%20photography%2C%20calm%20and%20trustworthy%20atmosphere%2C%20no%20people&width=900&height=900&seq=anedan-xray-01&orientation=squarish",
    items: [
      "Radiografía de tórax",
      "Radiografía de extremidades",
      "Radiografía de columna",
      "Radiografía de cráneo y senos paranasales",
      "Estudios para valoración preoperatoria",
      "Resultados digitales interpretados por médico",
    ],
  },
];

export const trustPoints = [
  { label: "Análisis clínicos", icon: "ri-test-tube-line" },
  { label: "Ultrasonido", icon: "ri-heart-pulse-line" },
  { label: "Electrocardiograma", icon: "ri-heart-3-line" },
  { label: "Estudios a domicilio", icon: "ri-home-smile-2-line" },
  { label: "Precios accesibles", icon: "ri-hand-coin-line" },
  { label: "Pagos con tarjeta", icon: "ri-bank-card-line" },
  { label: "Espacio LGBTQ+ friendly", icon: "ri-rainbow-line" },
];

export const testimonials = [
  {
    name: "Itzel Geraldine Yáñez Rodríguez",
    role: "Paciente",
    rating: 5,
    text: "Tuve una excelente experiencia en este laboratorio. Desde que llegué, el personal fue muy amable y atento, me explicaron todo el proceso con mucha paciencia y profesionalismo. Las instalaciones son limpias, organizadas y me sentí muy cómoda.",
    initials: "IY",
  },
  {
    name: "Antonio Cedillo",
    role: "Paciente de ultrasonido",
    rating: 5,
    text: "Agradable experiencia con el laboratorio, el doctor del ultrasonido fue muy profesional y sumamente paciente en todo momento, yo estaba muy tenso y él me dio la confianza y contestó cada una de mis dudas, ampliamente recomendable.",
    initials: "AC",
  },
  {
    name: "JoseSotomayor Lopez",
    role: "Paciente",
    rating: 5,
    text: "Me atendieron muy bien, son muy profesionales y los precios son súper accesibles, atención de primer nivel.",
    initials: "JL",
  },
];

export const faqs = [
  {
    question: "¿Necesito cita previa para mis estudios?",
    answer:
      "Puedes llamarnos al 55 3006 2938 para agendar tu cita o resolver dudas. Muchos análisis de rutina se pueden tomar el mismo día; te recomendamos llamar para confirmar disponibilidad y horarios.",
  },
  {
    question: "¿Tengo que ir en ayunas?",
    answer:
      "Depende del estudio. Algunos análisis (como glucosa o perfil de lípidos) requieren ayuno de 8 a 12 horas, mientras que otros no. Al agendar te indicamos exactamente cómo prepararte.",
  },
  {
    question: "¿Qué formas de pago aceptan?",
    answer:
      "Aceptamos efectivo y pagos con tarjeta de débito y crédito. Si tienes dudas sobre el costo de tus estudios, con gusto te damos una cotización por teléfono antes de tu visita.",
  },
  {
    question: "¿Cuánto tardan los resultados?",
    answer:
      "La mayoría de los análisis de rutina se entregan el mismo día o al día siguiente, según el estudio. Los resultados de ultrasonido los interpreta un médico y se entregan al momento de la consulta.",
  },
  {
    question: "¿Qué estudios realizan a domicilio?",
    answer:
      "Ofrecemos a domicilio análisis clínicos, electrocardiogramas y rayos X, sujetos a disponibilidad de agenda; los rayos X se realizan exclusivamente a domicilio. El ultrasonido se realiza en el laboratorio, con cita previa. Solo agenda tu visita al 55 3006 2938 y llevamos el personal y el equipo hasta tu casa con seguridad y comodidad, sin traslados ni salas de espera.",
  },
  {
    question: "¿El laboratorio es inclusivo y seguro?",
    answer:
      "Sí. Somos un espacio amigable con la comunidad LGBTQ+, con un equipo que te trata con respeto, paciencia y sin juicios. Queremos que te sientas cómoda o cómodo durante toda tu visita.",
  },
  {
    question: "¿Dónde están ubicados?",
    answer:
      "Cda. Novedades 92, Prensa Nacional, 54170 Tlalnepantla, Estado de México. Atendemos de lunes a sábado de 7:00 a.m. a 1:00 p.m., para que puedas hacerte tus estudios temprano. El domingo permanecemos cerrados.",
  },
];